'use es6';

import { Record } from 'immutable';
import { RequestStatus } from 'content-detail-ui/constants/base';
const DEFAULTS = {
  domain: '',
  id: 0,
  isAnyDomainExternal: false,
  isDnsCorrect: false,
  isInternalDomain: false,
  isResolving: false,
  status: RequestStatus.UNINITIALIZED
};
export default class Domain extends Record(DEFAULTS) {}